import { Icon } from '@chakra-ui/react'

import { CaseManagement } from '@/components/icons'

export const CaseManagementIcon = () => (
  <Icon as={CaseManagement} boxSize='32px' strokeColor='#353849' />
)
